import React, { useEffect } from 'react';
import { useSelector, connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import Logo from '../../images/Logo.png';
import { fetchSucursales } from '../../redux/actions/Sucursales';
import { fetchVehiculos } from '../../redux/actions/CategoriaVehiculos';
import { fetchVehiculosCatalogo } from '../../redux/actions/CategoriaVehiculosCatalogo';
import { fetchUbicaciones } from '../../redux/actions/Ubicaciones';
import { fetchPoliticas } from '../../redux/actions/Politicas';
import { fetchCoberturas } from '../../redux/actions/Coberturas';
import { fetchServicios } from '../../redux/actions/Servicios';
import { fetchFronteras } from '../../redux/actions/Fronteras';
import { fetchObjetivos } from '../../redux/actions/Objetivos';
import { fetchEnlaces } from '../../redux/actions/Enlaces';
import { fetchPuntosContacto } from '../../redux/actions/PuntosContacto';
import { fetchCarusel } from '../../redux/actions/Carusel';
import { fetchMoneda } from '../../redux/actions/CambioMoneda';
import { isLoading } from '../../redux/actions/Loading';
import { STEPS } from '../../redux/actions/PasosFormulario';
import { reset as resetForm } from 'redux-form';
import { reset } from '../../redux/actions/Coberturas';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faFacebookMessenger, faWhatsapp } from '@fortawesome/free-brands-svg-icons';




const Navbar = ({ bindData, isLoading, bindReset }) => {


    const catVehiculos = useSelector(state => state.categoriaVehiculosCatalogo);
    const enlaces = useSelector(state => state.enlaces);
    const { stepForm } = useSelector(state => state.pasosReservacion);
    const reservacion = useSelector(state => state.reservacion);

    const bindForm = () => {
        (STEPS.FINAL === stepForm) && bindReset()
        isLoading(true)
    }

    useEffect(() => { bindData() }, [bindData])

    
    
    return (
        <>

            <nav className="navbar navbar-dark navbar-expand-lg navbar-light fixed-top nav-interamerican">
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
                    aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <NavLink to="/" className="brand">
                    <img src={Logo} alt=".." />
                </NavLink>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav">
                        <li id={"btnReservaciones"} key={"btnReservaciones"} className="nav-item item">
                            <NavLink to="/reservaciones" activeClassName="active" className="nav-link" onClick={bindForm}>
                                RESERVACIONES
                                {(reservacion.Dias > 0) && <span className="tip-reservacion"></span>}
                            </NavLink>
                        </li>
                        <li id={"btnVehiculos"} key={"btnVehiculos"} className="nav-item dropdown" >
                            <NavLink to="/vehiculos" activeClassName="active"
                                className="nav-link dropdown-toggle" id="navbarDropdownMenuLink" role="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                VEHÍCULOS
                            </NavLink>
                            <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                {
                                    catVehiculos.map((veh) =>
                                        <div key={"veh-" + veh.Id}>
                                        {/*      <HashLink id={"veh-" + veh.Id} className="dropdown-item" to={"/vehiculos#" + veh.Id} onClick={bindForm} > {veh.Nombre}</HashLink>
                                          */}
                                          <HashLink id={"veh-" + veh.Id} className="dropdown-item" to={"/vehiculos/"+ veh.Id.toLowerCase() } onClick={bindForm} > {veh.Nombre}</HashLink> 
                                          
                                          
                                          {/*
                                            <HashLink id={"veh-" + veh.Id} className="dropdown-item" to={"/vehiculos/"+ veh.Id.toLowerCase()+"?type=" + veh.Id} onClick={bindForm} > {veh.Nombre}</HashLink> 
                                            */}
                                        </div>
                                    )
                                }
                            </div>
                        </li >
                        <li id={"btnNosotros"} key={"btnNosotros"} className="nav-item">
                            <NavLink activeClassName="active" to='/nosotros' className="nav-link" onClick={bindForm}>NOSOTROS</NavLink>
                        </li>
                        <li id={"btnPoliticas"} key={"btnPoliticas"} className="nav-item">
                            <NavLink to='/politicas' activeClassName="active" onClick={bindForm} className="nav-link" >SERVICIOS Y POLÍTICAS</NavLink>
                        </li>
                        <li id={"btnContactos"} key={"btnContactos"} className="nav-item">
                            <a href="#ContactosModal" className="nav-link" data-toggle="modal" data-target="#ContactosModal">CONTÁCTANOS</a>
                        </li>
                        <li id={"btnUbicaciones"} key={"btnUbicaciones"} className="nav-item">
                            <NavLink to='/ubicaciones' activeClassName="active" onClick={bindForm} className="nav-link">UBICACIONES</NavLink>
                        </li>
                      <li id="btnUbicaciones" key="btnLandingPage" className="nav-item">
                        <a
                            href="https://interamericanturismo.com/"
                            className="nav-link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            TURISMO Y NEGOCIOS
                        </a>
                        </li>
                    </ul>
                </div>
                <div className="navbar-expand" id="brands">

                    {/*   <div className="col-auto social-media">
                    <ul className="navbar-nav">

                        <li key={"btnFacebook"} className="nav-item">
                            <a href={enlaces.find(w => w.Id === "FACEBOOK")?.URL === undefined ? "#" : enlaces.find(w => w.Id === "FACEBOOK")?.URL} className="icon-facebook"><i><FontAwesomeIcon icon={faFacebookF} /></i></a>
                        </li>
                        <li key={"btnMessenger"} className="nav-item">
                            <a href={enlaces.find(w => w.Id === "MESSENGER")?.URL === undefined ? "#" : enlaces.find(w => w.Id === "MESSENGER")?.URL} className="icon-messenger"><i><FontAwesomeIcon icon={faFacebookMessenger} /></i></a>
                        </li>
                        <li key={"btnWhatsapp"} className="nav-item">
                            <a href={enlaces.find(w => w.Id === "WHATSAPP")?.URL === undefined ? "#" : enlaces.find(w => w.Id === "WHATSAPP")?.URL} className="icon-whatsapp"><i><FontAwesomeIcon icon={faWhatsapp} /></i></a>
                        </li>

                    </ul>
                </div> */}

                    <ul className="navbar-nav">
                        <li key={"btnFacebook"} className="nav-item">
                            <a className="nav-link" href={enlaces.find(w => w.Id === "FACEBOOK")?.URL === undefined ? "#" : enlaces.find(w => w.Id === "FACEBOOK")?.URL}><i><FontAwesomeIcon icon={faFacebookF} /></i></a>
                        </li>
                        <li key={"btnMessenger"} className="nav-item">
                            <a className="nav-link" href={enlaces.find(w => w.Id === "MESSENGER")?.URL === undefined ? "#" : enlaces.find(w => w.Id === "MESSENGER")?.URL}><i><FontAwesomeIcon icon={faFacebookMessenger} /></i></a>
                        </li>
                        <li key={"btnWhatsapp"} className="nav-item">
                            <a className="nav-link" href={enlaces.find(w => w.Id === "WHATSAPP")?.URL === undefined ? "#" : enlaces.find(w => w.Id === "WHATSAPP")?.URL}><i><FontAwesomeIcon icon={faWhatsapp} /></i></a>
                        </li>
                    </ul>
                </div>
            </nav>

        </>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        bindData: () => {
            dispatch(fetchSucursales());
            dispatch(fetchVehiculos());
            dispatch(fetchVehiculosCatalogo());
            dispatch(fetchUbicaciones());
            dispatch(fetchPoliticas());
            dispatch(fetchCoberturas());
            dispatch(fetchServicios());
            dispatch(fetchFronteras());
            dispatch(fetchObjetivos());
            dispatch(fetchEnlaces());
            dispatch(fetchPuntosContacto());
            dispatch(fetchCarusel());
            dispatch(fetchMoneda());
        },
        isLoading: value => dispatch(isLoading(value)),
        bindReset: () => {
            dispatch(reset())
            dispatch(resetForm("FormDataCliente"))
        }
    }
}

export default connect(null, mapDispatchToProps)(Navbar)
